import * as React from 'react';

const PaginateNext = (props) => (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='36' height='36' fill='#F5F5F5' />
    <g id='Main Page'>
      <rect
        width='1728'
        height='3382'
        transform='translate(-1073 -2005)'
        fill='white'
      />
      <circle
        id='Ellipse 2'
        cx='18'
        cy='18'
        r='18'
        transform='rotate(180 18 18)'
        fill='currentColor'
      />
      <g id='left-arrow 2'>
        <g id='Group'>
          <g id='Group_2'>
            <path
              id='Vector'
              d='M21.1375 17.4964L14.7779 23.8563C14.6028 24.031 14.5064 24.2646 14.5064 24.5137C14.5064 24.7629 14.6028 24.9963 14.7779 25.1713L15.3351 25.7283C15.51 25.9035 15.7437 26 15.9928 26C16.2418 26 16.4753 25.9035 16.6502 25.7283L24.2224 18.1562C24.3981 17.9807 24.4943 17.7462 24.4936 17.4968C24.4943 17.2464 24.3982 17.0121 24.2224 16.8364L16.6573 9.27173C16.4823 9.09647 16.2489 9 15.9997 9C15.7506 9 15.5172 9.09647 15.3421 9.27173L14.7849 9.82872C14.4224 10.1912 14.4224 10.7814 14.7849 11.1438L21.1375 17.4964Z'
              fill='white'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default PaginateNext;
